import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";
import type { QueryType } from "@/common/types/common";

import type {
    UserLoginType,
    UserRecoverType,
    UserRegisterType,
} from "@/common/types/user";

export async function userLogin(
    payload: UserLoginType
) {
    return await clientAxios.post(
        `admin/login`,
        payload
    );
}

export async function userRecover(
    payload: UserRecoverType
) {
    return await clientAxios.post(
        `admin/recover`,
        payload
    );
}

export async function userRecoverValid(
    payload: UserRecoverType
) {
    return await clientAxios.post(
        `admin/recover/valid`,
        payload
    );
}

export async function userRecoverPassword(
    payload: UserRecoverType
) {
    return await clientAxios.post(
        `admin/recover/password`,
        payload
    );
}

export async function userRecoverCheckEmail() {
    return await clientAxios.get(
        `admin/recover/check/email`
    );
}

export async function userProfile() {
    return await clientAxios.get(
        `admin/user/profile`
    );
}

export async function userAdd(
    payload: UserRegisterType
) {
    return await clientAxios.post(
        `admin/user/create`,
        payload
    );
}

export async function userList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/user/list${queryString}`
    );
}

export async function userUpdate(
    user_id: string,
    payload: UserRegisterType
) {
    return await clientAxios.put(
        `admin/user/${user_id}/update`,
        payload
    );
}

export async function userDel(
    user_id: string
) {
    return await clientAxios.del(
        `admin/user/${user_id}/delete`,
    );
}